<template>
  <div id="customization-dashboard" class="mc-customization-dashboard">
    <div
      v-if="isLoading"
      ref="loader-container"
      class="custom-dashboard__loader"
      :style="loaderStyle"
    >
      <img src="@/assets/images/mceasy-loader.gif" width="100" />
    </div>
    <iframe
      v-show="!isLoading"
      class="custom-dashboard__frame"
      :src="$store.state.identity.featureFlag.find(feature => feature.key == 'urlCustomizationDashboard').value"
      :style="frameStyle"
      @load="isLoading = false"
    />
  </div>
</template>

<script>
import iframeResize from 'iframe-resizer/js/iframeResizer'

export default {
  directives: {
    resize: {
      bind: function (el, { value = {} }) {
        el.addEventListener('load', () => iframeResize(value, el))
      },
      unbind: function (el) {
        el.iFrameResizer.removeListeners()
      },
    },
  },
  data() {
    return {
      loaderStyle: {},
      frameStyle: {
        width: '100%',
        overflow: 'hidden',
        height: '100vh',
      },
      isLoading: true,
    }
  },
  mounted() {
    const loader = this.$refs['loader-container']
    this.$set(this.loaderStyle, 'height', `${window.innerHeight - (loader.offsetTop + 150)}px`)
  },
}
</script>
